import { Box } from '@material-ui/core'
import React from 'react'

export default function SubmitButtonsContainer(props) {
    return <Box m={1} display='flex' gridGap={8} justifyContent='flex-end' {...props} />
}